import React, { useMemo } from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import RadioListField from '../../../../BaseModule/Components/Form/Components/RadioList/RadioListField';
import { RadioListItem } from '../../../../BaseModule/Components/Form/Components/RadioList/RadioList';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.RADIO_LIST }>;
}

const WizardRadioList: React.FC<Props> = ({ item }) => {
	const options: RadioListItem[] = useMemo(() => {
		return item.children.map(i => {
			return { title: i.title, value: i.value as string | boolean | number };
		});
	}, [item]);

	return (
		<RadioListField
			name={item.key}
			options={options}
			label={item.title}
			isRequired={item.settings?.required}
		/>
	);
};

export default WizardRadioList;
